// extracted by mini-css-extract-plugin
export default {"linkClass":"style-module--linkClass--8b-Tb","marginAuto":"style-module--marginAuto--O61+7","visible":"style-module--visible--EX4KP"};